export default "__VITE_ASSET__CceIM_M___"